/* DON'T EDIT THIS FILE: edit original and run build again */ // FIXME?: this should be a background-check independent type (future@replace-nosis)
export enum DocumentType {
  // tipos cuit:
  cuit = "cuit",
  cuil = "cuil",
  cdi = "cdi",
  // tipo documento:
  dni = "dni",
  dnim = "dnim", // D.N.I. (N° MÚLTIPLE)
  lc = "lc", // LIBRETA CIVICA
  le = "le", // LIBRETA DE ENROLAMIENTO
  ci = "ci", // CEDULA DE IDENTIDAD
  tram = "tram", // EN TRAMITE
  acta = "acta", // ACTA DE NACIMIENTO
  pas = "pas", // PASAPORTE
  indet = "indet", // INDETERMINADO
  cert = "cert", // CERTIFICADO DE MIGRACIÓN
  cermi = "cermi", // CERTIFICADO DE MOVIMIENTOS MIGRATORIOS
  diext = "diext", // DOCUMENTO IDENTIDAD EXTRANJERO
  indoc = "indoc", // ANSES INDOCUMENTADO
}
